import { render, staticRenderFns } from "./WhoAreYou.vue?vue&type=template&id=f992dc82&"
import script from "./WhoAreYou.vue?vue&type=script&lang=js&"
export * from "./WhoAreYou.vue?vue&type=script&lang=js&"
import style0 from "./WhoAreYou.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports